import React from "react";
import "./Information.css";
function Information({ information }) {
  return (
    <>
      <div className="information-container">
        <ul className="information">
          {Object.entries(information).map(([key, value]) => (
            <li key={key}>
              <strong>{key}:</strong> {value}
            </li>
          ))}
        </ul>
      </div>
    </>
  );
}

export default Information;
